import { useContext, useState } from "react";
import {
  HeaderSection,
  Links,
  Logo,
  MenuToggle,
  MobileNav,
} from "../styles/Header.styled";
import { RootContext } from "../context/RootContext";
import useQuery from "../hooks/useQuery";

export const Header = () => {
  const query = useQuery();
  const origin = query.get("origin") || "";
  const { providerData } = useContext<any>(RootContext);
  const [showNav, setShowNav] = useState(false);

  const linkHrefs: any = [
    // {
    //   title: "Service Areas",
    //   url: "",
    // },
    // {
    //   title: "About Us",
    //   url: "",
    // },
    // {
    //   title: "FAQs",
    //   url: "",
    // },
  ];

  const renderLogoUrl = () => {
    if (origin?.toLowerCase() === "lowerebill")
      return "https://www.lowerebill.com/images/logo.png";
    return null;
  };

  const logoUrl = renderLogoUrl();

  return (
    <HeaderSection>
      <Logo>
        {logoUrl && (
          <>
            <img src={logoUrl} alt="" height={40} />
            <span style={{ fontWeight: 100, padding: "0px 10px" }}>x</span>
          </>
        )}
        {providerData?.provider_id ? (
          <img
            src={`https://dorzjv601fuva.cloudfront.net/tx/${providerData.provider_id}.png`}
            width="125"
            alt="Provider Logo"
          />
        ) : (
          <div style={{ position: "relative" }}>
            <h2>EnergyGPT</h2>
            <i className="prototype">Prototype</i>
          </div>
        )}
      </Logo>

      <Links>
        {linkHrefs.map((item: any, index: number) => (
          <a href={item.url} target="_blank" key={index}>
            {item.title}
          </a>
        ))}
      </Links>

      {linkHrefs.length > 0 && (
        <MenuToggle
          active={`${showNav}`}
          onClick={() => {
            if (showNav) {
              document.body.style.overflow = "unset";
            } else {
              document.body.style.overflow = "hidden";
            }
            setShowNav(!showNav);
          }}
        />
      )}

      {showNav && (
        <MobileNav active={`${showNav}`}>
          {linkHrefs.map((item: any, index: number) => (
            <a href={item.url} target="_blank" key={index}>
              {item.title}
            </a>
          ))}
        </MobileNav>
      )}
    </HeaderSection>
  );
};
